// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iBXv","questions":"styles_questions__2iiZ3","footer":"styles_footer__2quIt"};